/** Comparación estable de `elementId` (string vs ObjectId u otros). */
function erElIdEq(a, b) {
	return String(a ?? "") === String(b ?? "");
}
function erSelectedIdsInclude(selectedIds, elementId) {
	return (selectedIds || []).some((id) => erElIdEq(id, elementId));
}

export { erElIdEq, erSelectedIdsInclude };
